import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'RoomOutput',
  props: {
    input: null,
    type: {
      default: 'long'
    },
    isEuro: {
      type: Boolean,
      default: false
    },
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var postFix = computed(function () {
      var _map$props$type;
      var map = {
        long: '-комнатная',
        short: '',
        cut: '-ком.'
      };
      return (_map$props$type = map[props.type]) !== null && _map$props$type !== void 0 ? _map$props$type : '-ком.';
    });
    var roomLabel = computed(function () {
      return "".concat(props.input).concat(props.isEuro ? 'E' : '');
    });
    var label = computed(function () {
      return props.type === 'short' ? 'Ст' : 'Студия';
    });
    return {
      __sfc: true,
      props: props,
      postFix: postFix,
      roomLabel: roomLabel,
      label: label
    };
  }
});